import { render } from "./LogoImage.vue?vue&type=template&id=484a320b&scoped=true"
import script from "./LogoImage.vue?vue&type=script&lang=js"
export * from "./LogoImage.vue?vue&type=script&lang=js"

import "./LogoImage.vue?vue&type=style&index=0&id=484a320b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484a320b"]])

export default __exports__